const n = {
  name: "TriangleUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.91943 16L18.0807 16L12.0001 8.39917L5.91943 16Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as TriangleUp
};
